import styles from './VServicesModalDeliveryDetails.module.css'

// Modal
import { useModalWindow } from "react-modal-global";
import useScrollBlock from "../../../../../../customHooks/useScrollBlock";
import PopupAppearLayout from "../../../../common/Modals/Layouts/PopupAppearLayout";
// 
import image from './image.jpg'

const VServicesModalDeliveryDetails = () => {

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();
    const closeModal = () => {
      // setTimeout(function(){allowScroll()}, 150);
      allowScroll()
      modal.close()
    } 
    
    return (
        <PopupAppearLayout classNameLayout={styles.popup__layout}>
            <div className={styles.container}>

                
                {/* HEADER */}
                <div className={styles.header_container}>
                    <div className={styles.header_title}>
                        <p>Служба доставки</p>
                    </div>
                    
                    <button
                        className={styles.popup_layout__close}
                        type="button"
                        onClick={closeModal}
                        aria-label="Закрыть"
                    >
                        &#9587;
                    </button>
                </div>
                
                {/* CONTENT */}
                <div className={styles.content__container}>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Вы можете подать заявку:
                        </div>
                        <div className={styles.text}>
                            <ol>
                                <li>
                                    В CALL CENTER диспетчерам c 08:00 до 20:00 по телефону:{' '}
                                    <a href="tel:+77719292288">+7 771 929 2288</a>
                                    <br />
                                    С 20:00 до 08:00 заявку можно отправить голосовой почтой на этот номер
                                </li>
                                <li>
                                    Через Robokassa.KZ - систему для приема онлайн-оплаты на нашем сайте в разделе КАТАЛОГ
                                </li>
                            </ol>
                        </div>
                    </div>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Условия и сроки выполнения Вашего заказа
                        </div>
                        <div className={styles.text}>
                            <ol>
                                <li>
                                    Доставка товара - на следующий день после подачи заявки, либо по согласованному ГРАФИКУ доставки воды в удобные для Вас дни, с 09:00 до 18:00, воскресенье - выходной день.
                                </li>
                                <li>
                                    Доставка в Талгар, ИЯФ (понедельник), Каскелен (среда), Конаев (четверг), Боралдай (пятница) - доставка 1 раз в неделю.
                                </li>
                                <li>
                                    Предлагаем возможность самовывоза с нашего склада по адресу: г. Алматы, ул. Наманганская, 43, с 10:00-12:00 и 13:00-16:00, при этом цена воды 18,9л составит 1200 тенге, с учетом НДС.
                                </li>
                            </ol>
                        </div>
                    </div>
                    
                    <div className={styles.row}>
                        <p className={styles.textAttention}>
                            Заявки на воду просим размещать заранее по телефонам диспетчерской службы. Доставка будет осуществлена на следующий день после оформления заказа.
                        </p>
                    </div>
                    
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Уважаемые клиенты, проживающие в горах и предгорьях г. Алматы и Алматинской области, Талгара, Каскелена.
                        </div>
                        <div className={styles.text}>
                            Уведомляем вас, что доставка воды в зимнее время года на труднодоступных участках дорог становится невозможной и небезопасной. При низких температурах, при образовании наледи на дорогах, наши груженые автомобили "ГАЗель" не могут подниматься. Просим Вас отнестись с пониманием и извинить нас за неудобства.
                        </div>
                    </div>

                    <div className={styles.imageBlock}>
                        <img className={styles.image} src={image} alt="Доставка воды" />
                    </div>

                    {/* buttons */}
                    <div className={styles.btnBlock}>
                        <button
                            className={styles.btn_return}
                            type="button"
                            onClick={closeModal}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>

            </div>
        </PopupAppearLayout>
    );
}

export default VServicesModalDeliveryDetails;